import React, { memo, useEffect, useState } from "react";
import Header from "../../layout/Header";
import { Tabs, Tab, Modal, CloseButton, Button } from "react-bootstrap";
import { decrypt } from "../../../utils/encodingdecoding";
import { getPromotion, getUser, updateProductData, updateUserData } from "../../../services/auth";
import CustomPagination from "../../partial/CustomPagination"
import swal from "sweetalert";
import { ValidatorForm } from "react-form-validator-core";
import SelectValidator from "../../partial/SelectValidator";
import { useNavigate } from "react-router-dom";

const UserManagement = () => {

    const [activeTab, setActiveTab] = useState("distributor");
    const navigate = useNavigate();
    const [loader, setLoader] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [response, setResponse] = useState([]);
    const [editRowId, setEditRowId] = useState(null);
    const [editData, setEditData] = useState({});
    const [show, setShow] = useState(false);
    const pageSize = 10;
    const [options] = useState([
        { label: "Distributor", value: "distributor" },
        { label: "Retailers", value: "retailer" },
        { label: "Customer ", value: "customer" },
        { label: "Influencer", value: "influencer" },
        { label: "Admin User ", value: "admin" },
    ]);
    const pageCount = Math.ceil(response?.length / pageSize);
    const handleClose = () => setShow(false);
    const fetchOffer = async (selectedTab = activeTab) => {
        setLoader(true);
        const token = JSON.parse(localStorage.getItem("token_gen"));
        const Id = decrypt(localStorage.getItem("Id"));
        try {
            const res = await getUser(token?.access_token, Id, selectedTab);
            setResponse(res.data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoader(false);
        }
    };


    useEffect(() => {
        fetchOffer();
    }, []);
    const onHandleSelect = (e) => {
        if (e.value) {
            navigate("/create-user", {
                state: e.value,
            });
        }
    };
    const handleEdit = (id) => {
        const data = response.find((item) => item.id === id);
        setEditRowId(id);
        setEditData(data);
    };

    const handleInputChange = (key, value) => {
        setEditData((prev) => ({ ...prev, [key]: value }));
    };

    const handleSave = async () => {
        setLoader(true)
        const token = JSON.parse(localStorage.getItem("token_gen"));
        try {
            await updateUserData(token?.access_token, editRowId, editData,).then((res) => {
                if (res.message == "Success") {
                    setEditRowId(null);
                    setLoader(false)
                    swal({
                        position: "center",
                        icon: "success",
                        title: "User data updated successfully",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                    fetchOffer();
                }
                else {
                    swal({
                        position: "center",
                        icon: "error",
                        title: "User data not updated",
                        showConfirmButton: false,
                        timer: 3000,
                    });
                }
            })

        } catch (err) {
            console.error(err);

        }
    };

    const formatDate = (dateStr) => {
        if (!dateStr) return "";
        const date = new Date(dateStr);
        return date.toLocaleDateString("en-GB");
    };
    const handleCancel = () => {
        setEditRowId(null);
        setEditData({});
    };
    const handleCampaigns = () => {
        setShow(true);
    };
    const onSubmit = () => { };
    return (
        <>
            <Header name={"User Management"} />
            {loader && (
                <div className="mainPreloaderMain">
                    <div className="mainPreloader">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
            )}
            <div className="dashboard__content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                            <div className="dashboard__heading align-items-end">
                                <div className="dashboard__headingLeft">
                                    <div className="dashboard__headingContent">
                                        <Button id="crate_new_cmp" onClick={handleCampaigns} className="btn btn-primary btn-lg">
                                            Create New User
                                        </Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="dashboard__transactionsCard">
                        <div className="dashboard__header">
                            <div className="dashboard__left">
                                <h4>User Management</h4>
                            </div>
                        </div>
                        <div className="dashboard__customerViewCard">
                            <div className="dashboard__customerViewPointsTabs">
                                <Tabs id="customerViewPointsTabs" activeKey={activeTab} onSelect={(k) => {
                                    setActiveTab(k);
                                    fetchOffer(k);
                                }}>
                                    <Tab eventKey="distributor" title="Distributor">
                                        {Array.isArray(response) && response.length > 0 ? (
                                            <div>
                                                <div style={{ overflowX: "auto" }}>
                                                    <table className="table table-bordered" style={{ minWidth: "1000px" }}>
                                                        <thead>
                                                            <tr>
                                                                {Object.keys(response[0])
                                                                    .filter((key) =>
                                                                        !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                                    )
                                                                    .map((key) => (
                                                                        <th key={key}>{key}</th>
                                                                    ))}
                                                                <th style={{ position: "sticky", zIndex: 5, right: 0, background: "white" }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {response
                                                                .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                                                                .map((item) => (
                                                                    <tr key={item.id}>
                                                                        {Object.entries(item)
                                                                            .filter(([key]) =>
                                                                                !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                                            )
                                                                            .map(([key, value]) => (
                                                                                <td key={key}>
                                                                                    {editRowId === item.id && key !== "createdAt" ? (
                                                                                        <input
                                                                                            className="editData"
                                                                                            value={editData[key] || ""}
                                                                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                                                                        />
                                                                                    ) : key === "createdAt" ? (
                                                                                        formatDate(value)
                                                                                    ) : typeof value === "object" && value !== null ? (
                                                                                        JSON.stringify(value)
                                                                                    ) : (
                                                                                        value
                                                                                    )}
                                                                                </td>
                                                                            ))}
                                                                        <td style={{ position: "sticky", zIndex: 1, right: 0, background: "white" }}>
                                                                            {editRowId === item.id ? (
                                                                                <div style={{ display: "flex", justifyContent: "center", }}>
                                                                                    <button className="btn btn-sm btn-success" onClick={handleSave}>
                                                                                        Save
                                                                                    </button>
                                                                                    <button
                                                                                        className="btn btn-sm btn-secondary"
                                                                                        onClick={handleCancel}
                                                                                        style={{ marginLeft: "5px" }}
                                                                                    >
                                                                                        Cancel
                                                                                    </button>
                                                                                </div>
                                                                            ) : (
                                                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                                                    <button
                                                                                        className="btn btn-sm btn-outline-primary"
                                                                                        onClick={() => handleEdit(item.id)}
                                                                                    >
                                                                                        Edit
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="dashboard__paginationBox mt-2">
                                                    <CustomPagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pageCount} value={5} />
                                                </div>
                                            </div>
                                        ) : (
                                            <p className="text-center"> No data found</p>
                                        )}

                                    </Tab>
                                    <Tab eventKey="retailer" title="Retailers">
                                        {Array.isArray(response) && response.length > 0 ? (
                                            <div>
                                                <div style={{ overflowX: "auto" }}>
                                                    <table className="table table-bordered" style={{ minWidth: "1000px" }}>
                                                        <thead>
                                                            <tr>
                                                                {Object.keys(response[0])
                                                                    .filter((key) =>
                                                                        !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                                    )
                                                                    .map((key) => (
                                                                        <th key={key}>{key}</th>
                                                                    ))}
                                                                <th style={{ position: "sticky", zIndex: 5, right: 0, background: "white" }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {response
                                                                .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                                                                .map((item) => (
                                                                    <tr key={item.id}>
                                                                        {Object.entries(item)
                                                                            .filter(([key]) =>
                                                                                !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                                            )
                                                                            .map(([key, value]) => (
                                                                                <td key={key}>
                                                                                    {editRowId === item.id && key !== "createdAt" ? (
                                                                                        <input
                                                                                            className="editData"
                                                                                            value={editData[key] || ""}
                                                                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                                                                        />
                                                                                    ) : key === "createdAt" ? (
                                                                                        formatDate(value)
                                                                                    ) : typeof value === "object" && value !== null ? (
                                                                                        JSON.stringify(value)
                                                                                    ) : (
                                                                                        value
                                                                                    )}
                                                                                </td>
                                                                            ))}
                                                                        <td style={{ position: "sticky", zIndex: 1, right: 0, background: "white" }}>
                                                                            {editRowId === item.id ? (
                                                                                <div style={{ display: "flex", justifyContent: "center", }}>
                                                                                    <button className="btn btn-sm btn-success" onClick={handleSave}>
                                                                                        Save
                                                                                    </button>
                                                                                    <button
                                                                                        className="btn btn-sm btn-secondary"
                                                                                        onClick={handleCancel}
                                                                                        style={{ marginLeft: "5px" }}
                                                                                    >
                                                                                        Cancel
                                                                                    </button>
                                                                                </div>
                                                                            ) : (
                                                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                                                    <button
                                                                                        className="btn btn-sm btn-outline-primary"
                                                                                        onClick={() => handleEdit(item.id)}
                                                                                    >
                                                                                        Edit
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="dashboard__paginationBox mt-2">
                                                    <CustomPagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pageCount} value={5} />
                                                </div>
                                            </div>
                                        ) : (
                                            <p className="text-center">No data found</p>
                                        )}

                                    </Tab>
                                    <Tab eventKey="customer" title="Customer">
                                        {Array.isArray(response) && response.length > 0 ? (
                                            <div>
                                                <div style={{ overflowX: "auto" }}>
                                                    <table className="table table-bordered" style={{ minWidth: "1000px" }}>
                                                        <thead>
                                                            <tr>
                                                                {Object.keys(response[0])
                                                                    .filter((key) =>
                                                                        !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                                    )
                                                                    .map((key) => (
                                                                        <th key={key}>{key}</th>
                                                                    ))}
                                                                <th style={{ position: "sticky", zIndex: 5, right: 0, background: "white" }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {response
                                                                .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                                                                .map((item) => (
                                                                    <tr key={item.id}>
                                                                        {Object.entries(item)
                                                                            .filter(([key]) =>
                                                                                !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                                            )
                                                                            .map(([key, value]) => (
                                                                                <td key={key}>
                                                                                    {editRowId === item.id && key !== "createdAt" ? (
                                                                                        <input
                                                                                            className="editData"
                                                                                            value={editData[key] || ""}
                                                                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                                                                        />
                                                                                    ) : key === "createdAt" ? (
                                                                                        formatDate(value)
                                                                                    ) : typeof value === "object" && value !== null ? (
                                                                                        JSON.stringify(value)
                                                                                    ) : (
                                                                                        value
                                                                                    )}
                                                                                </td>
                                                                            ))}
                                                                        <td style={{ position: "sticky", zIndex: 1, right: 0, background: "white" }}>
                                                                            {editRowId === item.id ? (
                                                                                <div style={{ display: "flex", justifyContent: "center", }}>
                                                                                    <button className="btn btn-sm btn-success" onClick={handleSave}>
                                                                                        Save
                                                                                    </button>
                                                                                    <button
                                                                                        className="btn btn-sm btn-secondary"
                                                                                        onClick={handleCancel}
                                                                                        style={{ marginLeft: "5px" }}
                                                                                    >
                                                                                        Cancel
                                                                                    </button>
                                                                                </div>
                                                                            ) : (
                                                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                                                    <button
                                                                                        className="btn btn-sm btn-outline-primary"
                                                                                        onClick={() => handleEdit(item.id)}
                                                                                    >
                                                                                        Edit
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="dashboard__paginationBox mt-2">
                                                    <CustomPagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pageCount} value={5} />
                                                </div>
                                            </div>
                                        ) : (
                                            <p className="text-center">No data found</p>
                                        )}

                                    </Tab>
                                    <Tab eventKey="influencer" title="Influencer">
                                        {Array.isArray(response) && response.length > 0 ? (
                                            <div>
                                                <div style={{ overflowX: "auto" }}>
                                                    <table className="table table-bordered" style={{ minWidth: "1000px" }}>
                                                        <thead>
                                                            <tr>
                                                                {Object.keys(response[0])
                                                                    .filter((key) =>
                                                                        !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                                    )
                                                                    .map((key) => (
                                                                        <th key={key}>{key}</th>
                                                                    ))}
                                                                <th style={{ position: "sticky", zIndex: 5, right: 0, background: "white" }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {response
                                                                .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                                                                .map((item) => (
                                                                    <tr key={item.id}>
                                                                        {Object.entries(item)
                                                                            .filter(([key]) =>
                                                                                !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                                            )
                                                                            .map(([key, value]) => (
                                                                                <td key={key}>
                                                                                    {editRowId === item.id && key !== "createdAt" ? (
                                                                                        <input
                                                                                            className="editData"
                                                                                            value={editData[key] || ""}
                                                                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                                                                        />
                                                                                    ) : key === "createdAt" ? (
                                                                                        formatDate(value)
                                                                                    ) : typeof value === "object" && value !== null ? (
                                                                                        JSON.stringify(value)
                                                                                    ) : (
                                                                                        value
                                                                                    )}
                                                                                </td>
                                                                            ))}
                                                                        <td style={{ position: "sticky", zIndex: 1, right: 0, background: "white" }}>
                                                                            {editRowId === item.id ? (
                                                                                <div style={{ display: "flex", justifyContent: "center", }}>
                                                                                    <button className="btn btn-sm btn-success" onClick={handleSave}>
                                                                                        Save
                                                                                    </button>
                                                                                    <button
                                                                                        className="btn btn-sm btn-secondary"
                                                                                        onClick={handleCancel}
                                                                                        style={{ marginLeft: "5px" }}
                                                                                    >
                                                                                        Cancel
                                                                                    </button>
                                                                                </div>
                                                                            ) : (
                                                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                                                    <button
                                                                                        className="btn btn-sm btn-outline-primary"
                                                                                        onClick={() => handleEdit(item.id)}
                                                                                    >
                                                                                        Edit
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="dashboard__paginationBox mt-2">
                                                    <CustomPagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pageCount} value={5} />
                                                </div>
                                            </div>
                                        ) : (
                                            <p className="text-center">No data found</p>
                                        )}


                                    </Tab>
                                    <Tab eventKey="admin" title="Admin User">

                                        {Array.isArray(response) && response.length > 0 ? (
                                            <div>
                                                <div style={{ overflowX: "auto" }}>
                                                    <table className="table table-bordered" style={{ minWidth: "1000px" }}>
                                                        <thead>
                                                            <tr>
                                                                {Object.keys(response[0])
                                                                    .filter((key) =>
                                                                        !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                                    )
                                                                    .map((key) => (
                                                                        <th key={key}>{key}</th>
                                                                    ))}
                                                                <th style={{ position: "sticky", zIndex: 5, right: 0, background: "white" }}>Action</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {response
                                                                .slice(currentPage * pageSize, (currentPage + 1) * pageSize)
                                                                .map((item) => (
                                                                    <tr key={item.id}>
                                                                        {Object.entries(item)
                                                                            .filter(([key]) =>
                                                                                !["merchantCode", "createdAt", "discriminator", "productMasterFile", "updatedAt", "_rid", "_self", "_etag", "_attachments", "_ts", "id"].includes(key)
                                                                            )
                                                                            .map(([key, value]) => (
                                                                                <td key={key}>
                                                                                    {editRowId === item.id && key !== "createdAt" ? (
                                                                                        <input
                                                                                            className="editData"
                                                                                            value={editData[key] || ""}
                                                                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                                                                        />
                                                                                    ) : key === "createdAt" ? (
                                                                                        formatDate(value)
                                                                                    ) : typeof value === "object" && value !== null ? (
                                                                                        JSON.stringify(value)
                                                                                    ) : (
                                                                                        value
                                                                                    )}
                                                                                </td>
                                                                            ))}
                                                                        <td style={{ position: "sticky", zIndex: 1, right: 0, background: "white" }}>
                                                                            {editRowId === item.id ? (
                                                                                <div style={{ display: "flex", justifyContent: "center", }}>
                                                                                    <button className="btn btn-sm btn-success" onClick={handleSave}>
                                                                                        Save
                                                                                    </button>
                                                                                    <button
                                                                                        className="btn btn-sm btn-secondary"
                                                                                        onClick={handleCancel}
                                                                                        style={{ marginLeft: "5px" }}
                                                                                    >
                                                                                        Cancel
                                                                                    </button>
                                                                                </div>
                                                                            ) : (
                                                                                <div style={{ display: "flex", justifyContent: "center" }}>
                                                                                    <button
                                                                                        className="btn btn-sm btn-outline-primary"
                                                                                        onClick={() => handleEdit(item.id)}
                                                                                    >
                                                                                        Edit
                                                                                    </button>
                                                                                </div>
                                                                            )}
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="dashboard__paginationBox mt-2">
                                                    <CustomPagination currentPage={currentPage} setCurrentPage={setCurrentPage} pageCount={pageCount} value={5} />
                                                </div>
                                            </div>
                                        ) : (
                                            <p className="text-center">No data found</p>
                                        )}

                                    </Tab>
                                </Tabs>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal show={show} id="showm" onHide={handleClose} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title style={{ fontSize: "16px", fontWeight: 600 }}>Create New User</Modal.Title>
                    <CloseButton onClick={handleClose} variant="black" />
                </Modal.Header>
                <Modal.Body>
                    <p>Please select which type of User you want to create</p>
                    <div className="form-group">
                        <ValidatorForm onSubmit={onSubmit}>
                            <SelectValidator placeholder="Select" className="" name="choice" options={options} onChange={onHandleSelect} />
                        </ValidatorForm>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="primary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal >
        </>
    );
};

export default UserManagement;
